const API_BASE_URL = 'https://pricenote.co.kr:10443';

// 마지막 거래일 가져오기
export const getLastRunDate = async (ticker) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/stock-detail/${ticker}/run-date`, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.runDate;
  } catch (error) {
    console.error('Error fetching last run date:', error);
    // 에러 시 오늘 날짜 반환
    return new Date().toISOString().split('T')[0];
  }
};

const getRunDate = () => {
  // return '2025-07-18'; // Fixed date for now 2
  const today = new Date().toISOString().split('T')[0];
  return today; // Use today's date
};

export const getInvestmentRecommendation = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/summary-report/${ticker}/investment-recommendation?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching investment recommendation:', error);
    throw error;
  }
};

export const getNewsAnalysis = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/summary-report/${ticker}/news?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching news analysis:', error);
    throw error;
  }
};

export const getRiskAnalysis = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/summary-report/${ticker}/risk?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching risk analysis:', error);
    throw error;
  }
};

export const getSentimentAnalysis = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/summary-report/${ticker}/sentiment?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching sentiment analysis:', error);
    throw error;
  }
};

export const getTechnicalAnalysis = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/summary-report/${ticker}/technical?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching technical analysis:', error);
    throw error;
  }
};

export const getFundamentalAnalysis = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/summary-report/${ticker}/fundamental?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching fundamental analysis:', error);
    throw error;
  }
};

export const getStockDetailFundamental = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/stock-detail/${ticker}/fundamental?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching stock detail fundamental:', error);
    throw error;
  }
};

export const getStockDetailTechnical = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/stock-detail/${ticker}/technical?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching stock detail technical:', error);
    throw error;
  }
};

export const getStockDetailNews = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/stock-detail/${ticker}/news?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching stock detail news:', error);
    throw error;
  }
};

export const getStockDetailSummary = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/stock-detail/${ticker}/summary?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error) {
    console.error('Error fetching stock detail summary:', error);
    throw error;
  }
};

export const getInvestmentReport = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/report/${ticker}/investment-recommendation?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching investment report:', error);
    throw error;
  }
};

export const getNewsReport = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/report/${ticker}/news?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching news report:', error);
    throw error;
  }
};

export const getTechnicalReport = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/report/${ticker}/technical?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching technical report:', error);
    throw error;
  }
};

export const getFundamentalReport = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/report/${ticker}/fundamental?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching fundamental report:', error);
    throw error;
  }
};

export const getSentimentReport = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/report/${ticker}/sentiment?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching sentiment report:', error);
    throw error;
  }
};

export const getRiskReport = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/report/${ticker}/risk?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching risk report:', error);
    throw error;
  }
};

export const getDashboardMainContent = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/dashboard/dashboard-main-content`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching dashboard main content:', error);
    throw error;
  }
};

export const getDashboardMarketData = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/dashboard/dashboard-market-data`, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching dashboard market data:', error);
    throw error;
  }
};

export const getSearchTickers = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/search/tickers`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching search tickers:', error);
    throw error;
  }
};

export const searchStocks = async (query) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/search?query=${encodeURIComponent(query)}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error searching stocks:', error);
    throw error;
  }
};

export const getStockDetailCommunity = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/stock-detail/${ticker}/community?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching stock detail community:', error);
    throw error;
  }
};

export const getShortPositionAnalysis = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/analysis/short-position/${ticker}?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching short position analysis:', error);
    throw error;
  }
};

// 임시 로그인으로 토큰 발급
export const loginTemp = async (username) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/auth/login-temp`, {
      method: 'POST',
      headers: {
        'accept': '*/*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username: username
      })
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error logging in:', error);
    throw error;
  }
};

// 즐겨찾기 목록 가져오기
export const getFavoriteList = async (accessToken) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/auth/favorite`, {
      method: 'GET',
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${accessToken}`
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching favorite list:', error);
    throw error;
  }
};

// 즐겨찾기 추가/삭제 (통합 API)
export const toggleFavorite = async (accessToken, ticker, isFavorite) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/auth/favorite`, {
      method: 'PUT',
      headers: {
        'accept': '*/*',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
      body: JSON.stringify({
        ticker: ticker,
        isFavorite: isFavorite
      })
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error toggling favorite:', error);
    throw error;
  }
};

// 하위 호환성을 위한 래퍼 함수들
export const addFavorite = async (accessToken, ticker) => {
  return await toggleFavorite(accessToken, ticker, true);
};

export const deleteFavorite = async (accessToken, ticker) => {
  return await toggleFavorite(accessToken, ticker, false);
};

// ===== Community APIs =====

// localStorage에서 토큰 가져오기
export const getAccessToken = () => {
  try {
    const tokenInfo = localStorage.getItem('tokenInfo');
    if (tokenInfo) {
      const parsedTokenInfo = JSON.parse(tokenInfo);
      // 토큰 만료 시간 체크
      if (parsedTokenInfo.expireTime && Date.now() < parsedTokenInfo.expireTime) {
        return parsedTokenInfo.accessToken;
      }
    }
    return null;
  } catch (error) {
    console.error('Error getting access token:', error);
    return null;
  }
};

// 커뮤니티 게시글 목록 가져오기
export const getCommunityPosts = async (cursor = null) => {
  try {
    const url = cursor 
      ? `${API_BASE_URL}/api/v1/open/community?cursor=${cursor}`
      : `${API_BASE_URL}/api/v1/open/community`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch community posts');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching community posts:', error);
    throw error;
  }
};

// 댓글 목록 가져오기
export const getCommunityReplies = async (communityNo) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/community/reply?communityNo=${communityNo}`, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch replies');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching replies:', error);
    throw error;
  }
};
export const getUserInfo = async () => {
  try {
    const token = getAccessToken();
    if (!token) {
      throw new Error('No access token available');
    }

    const response = await fetch(`${API_BASE_URL}/api/v1/user`, {
      method: 'GET',
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch user info');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching user info:', error);
    throw error;
  }
};

// 게시글/댓글 작성
export const submitCommunityPost = async (content, parentCommunityNo = null) => {
  try {
    const token = getAccessToken();
    if (!token) {
      throw new Error('No access token available');
    }

    const response = await fetch(`${API_BASE_URL}/api/v1/auth/community`, {
      method: 'POST',
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        content: content.trim(),
        parentCommunityNo: parentCommunityNo || 0
      })
    });

    if (!response.ok) {
      throw new Error('Failed to submit post');
    }

    return await response.json();
  } catch (error) {
    console.error('Error submitting post:', error);
    throw error;
  }
};

// X 트윗 데이터 가져오기
export const getXTweetData = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/dashboard/x`, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching X tweet data:', error);
    throw error;
  }
};

// 공포 탐욕 지수 가져오기
export const getFearGreedIndex = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/dashboard/fear-and-greed-index`, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching fear and greed index:', error);
    throw error;
  }
};

// 주식 랭킹 가져오기
export const getStockRanking = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/dashboard/stock-ranking`, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching stock ranking:', error);
    throw error;
  }
};